import React from 'react';
import Icon from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SebraeplaceLogoSVG } from '../../../../images/svgs/sebraeplace/logo-sebraeplace.svg';
import { ReactComponent as MenuIcon } from '../../../../images/svgs/menu.svg';
import { ReactComponent as MenuListIcon } from '../../../../images/svgs/menu-list.svg';
import { ReactComponent as ExitIcon } from '../../../../images/svgs/exit-button.svg';
import LogoDev from '../../../../images/webps/logo-dev.webp';
import { environmentDEV } from '../../../../shared/util/environmentVariables';
import Button from '../../../../components/ui/Button';
import { BagIcon } from '../../../../components/ui/icons';
import HeaderSearch from '../HeaderSearch/HeaderSearch';
import NotificationsMenu from '../NotificationsMenu/NotificationsMenu';
import ProfileMenu from '../ProfileMenu/ProfileMenu';
import AvatarPadrao from '../../../../images/svgs/avatar-padrao.svg';
import styles from './HeaderBar.module.css';

export default function HeaderBar(props) {
  const { t } = useTranslation('header');
  const {
    pessoa,
    vinculos,
    exitButton,
    menuList,
    handleMenu,
    environment,
    canRenderActions,
    isPersonLoaded,
    links
  } = props;

  let vinculoAtual = null;
  if (pessoa && pessoa.vinculo) vinculoAtual = pessoa.vinculo;

  const checkBotaoFornecedor = () => {
    if (!vinculos || !isPersonLoaded) return false;
    return vinculos.every(v => v.papeis && !v.papeis.includes('FORNECEDOR'));
  };

  const getMenuIcon = () => {
    if (exitButton) return null;
    const cls = menuList ? styles.menuListHeader : styles.menuHeader;
    const Component = menuList ? MenuListIcon : MenuIcon;
    return (
      <div className={`${cls} cursor-pointer`} onClick={handleMenu}>
        <Icon id='menu-icon' component={Component} />
      </div>
    );
  };

  const goToLogin = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('link')) {
      return `${links.login}/?requestedURL=${window.location.href}`;
    }
    return links.login;
  };

  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.left}>
          {pessoa && getMenuIcon()}
          {exitButton && (
            <button
              type='button'
              className={`${styles.exitBtn} cursor-pointer`}
              onClick={handleMenu}
              aria-label={t('BACK')}>
              <Icon id='menu-icon' component={ExitIcon} />
            </button>
          )}
          <Link to='/' className={styles.logoLink}>
            <SebraeplaceLogoSVG
              className={styles.logo}
              aria-label='Sebraeplace'
            />
            {environmentDEV.includes(environment) && (
              <img
                src={LogoDev}
                style={{
                  position: 'absolute',
                  margin: '10px 12px 10px 40px',
                  height: '40px',
                  width: '50px'
                }}
                alt=''
              />
            )}
          </Link>
        </div>

        {canRenderActions === undefined || canRenderActions === true ? (
          <div className={styles.right}>
            <HeaderSearch links={links} />

            {pessoa && !vinculoAtual && checkBotaoFornecedor() && (
              <Button
                as={Link}
                to={links.cadastroFornecedorCliente}
                variant='primary'
                size='small'
                className={`tornar-se-fornecedor ${styles.supplierBtn}`}>
                {t('WANT_TO_BE_SUPPLIER')}
              </Button>
            )}

            {!pessoa && (
              <>
                <Button
                  as='a'
                  href={goToLogin()}
                  variant='secondary'
                  size='small'
                  className={styles.authBtn}>
                  {t('ENTER')}
                </Button>
                <Button
                  as='a'
                  href={`${links.login}/cadastro`}
                  variant='primary'
                  size='small'
                  className={styles.authBtn}>
                  {t('CREATE_YOUR_ACCOUNT')}
                </Button>
              </>
            )}

            <div className={styles.iconGroup}>
              {props.showNotifications && (
                <NotificationsMenu
                  notifications={props.notifications}
                  hasNotifications={props.hasNotifications}
                  qtdNotificacoes={props.qtdNotificacoes}
                  seeAll={props.seeAll}
                  setSeeAll={props.setSeeAll}
                  getNotificationsAll={props.getNotificationsAll}
                  notificacoesLoading={props.notificacoesLoading}
                  marcarNotificacaoComoLida={props.marcarNotificacaoComoLida}
                  links={links}
                />
              )}

              {pessoa && !pessoa.vinculo && (
                <Link to={links.carrinho} className={styles.iconBtn}>
                  <BagIcon size={18} style={{ color: 'var(--ui-blue-link)' }} />
                </Link>
              )}
            </div>

            {pessoa && (
              <ProfileMenu
                pessoa={pessoa}
                vinculos={vinculos}
                setarPessoaAtual={props.setarPessoaAtual}
                setarPessoaAtualLoading={props.setarPessoaAtualLoading}
                links={links}
                allowsAffiliate={props.allowsAffiliate}
                okThirdSetup={props.okThirdSetup}
                setSeeAll={props.setSeeAll}
              />
            )}
          </div>
        ) : (
          <img
            src={AvatarPadrao}
            className={styles.avatarPadrao}
            alt={t('AVATAR_ALT')}
          />
        )}
      </div>
    </div>
  );
}
